import { trans } from 'sharedKernel/i18n'
import React from 'react'
import { dateFormater } from 'sharedKernel/handlers'
import { stepStyles } from './behavior'
import { Container } from 'react-bootstrap'
import Stepper from '@mui/material/Stepper'
import Step from '@mui/material/Step'
import StepLabel from '@mui/material/StepLabel'
import { StepContent } from './style'

interface TimelineProps {
  steps?: {
    launchDate?: string
    applicationStartDate?: string
    finalSelectionDate?: string
    evaluationStartDate?: string
    closingDate?: string
  }
}

export const Timeline = ({ steps = {} }: any): JSX.Element => {
  const labels = {
    launch: trans('Início das Inscrições'),
    finalSelection: trans('Encerramento das Inscrições'),
    evaluation: trans('Início das Avaliações'),
    closing: trans('Encerramento das Avaliações')
  }

  const checkDate = (date: string | undefined): JSX.Element => {
    if (date !== undefined) {
      return <span>{dateFormater(date)}</span>
    }
    return <></>
  }

  const getCurrentEvaluationStep = () => {
    const evaluationSteps = steps?.evaluation?.steps ?? []

    if (evaluationSteps.length === 0) return null

    const today = new Date()
    const todayOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate())

    const parseDateOnly = (value?: string) => {
      if (!value) return undefined
      const d = new Date(value)
      if (isNaN(d.getTime())) return undefined
      return new Date(d.getFullYear(), d.getMonth(), d.getDate())
    }

    const orderedSteps = evaluationSteps
      .map((step: any) => ({
        ...step,
        _start: parseDateOnly(step.startDate),
        _end: parseDateOnly(step.closingDate)
      }))
      .sort((a: any, b: any) => {
        if (!a._start && !b._start) return 0
        if (!a._start) return 1
        if (!b._start) return -1
        return a._start.getTime() - b._start.getTime()
      })

    const current = orderedSteps.find(
      (step: any) =>
        step._start &&
        step._end &&
        step._start.getTime() <= todayOnly.getTime() &&
        todayOnly.getTime() <= step._end.getTime()
    )

    if (current) return current

    const allEnded = orderedSteps.every(
      (step: any) => step._end && step._end.getTime() < todayOnly.getTime()
    )

    if (allEnded) return orderedSteps[orderedSteps.length - 1]

    const nextFuture = orderedSteps.find(
      (step: any) => step._start && step._start.getTime() > todayOnly.getTime()
    )

    return nextFuture ?? orderedSteps[0]
  }

  const currentStep = getCurrentEvaluationStep()

  return (
    <Container>
      <Stepper activeStep={0} alternativeLabel className='overflow-scroll' >
        <Step sx={stepStyles}>
          <StepLabel>
            <StepContent>
              <span>{labels.launch}</span>
              {checkDate(steps.applicationForm?.applicationStartDate)}
            </StepContent>
          </StepLabel>
        </Step>
        <Step sx={stepStyles}>
          <StepLabel>
            <StepContent>
              <span>{labels.finalSelection}</span>
              {checkDate(steps.applicationForm?.finalSelectionDate)}
            </StepContent>
          </StepLabel>
        </Step>
        <Step sx={stepStyles}>
          <StepLabel>
            <StepContent>
              <span>{labels.evaluation}</span>
              {checkDate(currentStep?.startDate)}
            </StepContent>
          </StepLabel>
        </Step>
        <Step sx={stepStyles}>
          <StepLabel>
            <StepContent>
              <span>{labels.closing}</span>
              {checkDate(currentStep?.closingDate)}
            </StepContent>
          </StepLabel>
        </Step>
      </Stepper>
    </Container>
  )
}
